import { TrashEmail } from "@zickko/shared/src/models/TrashEmail";
import { TrashEmailListItemWidget } from "./TrashEmailListItemWidget";
import { InboundEmail, OutboundEmail } from "@zickko/shared";

type Props = {
  emailList: TrashEmail[];
  onSelectEmail: (email) => void;
};

export const TrashEmailListWidget = (props: Props) => {
  return (
    <div className="list-container">
      {props.emailList.length === 0 ? (
        <div className="no-emails-message">No emails available.</div>
      ) : (
        props.emailList.map((email) => (
          <TrashEmailListItemWidget
            email={email.email}
            key={email.emailId}
            onSelectEmail={() => props.onSelectEmail(email)}
          />
        ))
      )}
    </div>
  );
};
